// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>4</span>&nbsp;&nbsp;Let those who seek after my life be shamed and disgraced;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;let those who plot my ruin fall back and be put to confusion.<br> </p> </div></div>";
// Exports
module.exports = code;